import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import {
  adt,
  array,
  date,
  eq,
  iots,
  number,
  option,
  ord,
  pipe,
  string,
  struct,
} from '@code-expert/prelude';
import { BlankConfigC } from '/imports/modules/Quizzes/clozetext/domain/BlankConfig';

//--------------------------------------------------------------------------------------------------

export const QuestionIdBrand = Symbol('QuestionId');
export const QuestionId = mkEntityIdCodec(QuestionIdBrand);
export type QuestionId = iots.TypeOf<typeof QuestionId>;
export const eqQuestionId: eq.Eq<QuestionId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const QuestionVersionIdBrand = Symbol('QuestionVersionId');
export const QuestionVersionId = mkEntityIdCodec(QuestionVersionIdBrand);
export type QuestionVersionId = iots.TypeOf<typeof QuestionVersionId>;

//--------------------------------------------------------------------------------------------------

const baseQuestionProps = {
  _id: QuestionVersionId,
  questionId: QuestionId,
  createdAt: iots.date,
  updatedAt: iots.date,
  title: iots.maxLengthString(80),
  points: iots.Nat,
};

export const ClozeQuestion = iots.struct(
  {
    ...baseQuestionProps,
    type: iots.literal('cloze'),
  },
  {
    content: iots.string,
    blankConfigs: iots.array(BlankConfigC),
  },
);

export type ClozeQuestion = iots.TypeOf<typeof ClozeQuestion>;

export const Question = ClozeQuestion;

export type Question = iots.TypeOf<typeof ClozeQuestion>;

export const foldQuestionType = adt.foldFromProp('type');

export const getQuestionOrd = (order: Array<QuestionId>): ord.Ord<Pick<Question, 'questionId'>> =>
  pipe(
    number.Ord,
    ord.contramap(({ questionId }) =>
      pipe(
        order,
        array.findIndex(eq.isEqualTo(eqQuestionId)(questionId)),
        option.getOrElse(() => 0),
      ),
    ),
  );

export const ordQuestionByCreatedAt: ord.Ord<Pick<Question, 'createdAt'>> = pipe(
  date.Ord,
  ord.contramap(struct.get('createdAt')),
);

//--------------------------------------------------------------------------------------------------

export const QUESTION_LACKS_TITLE_WARNING = 'Provide a title';

export const eqQuestionLacksTitleWarning = eq.isEqualTo(string.Eq)(QUESTION_LACKS_TITLE_WARNING);
